const search = () => {
    const selectors = {
        // Search Modal
        searchModal: '[data-search-modal]',
        searchModalToggle: '[data-search-modal-toggle]',
        searchModalScroll: '[data-search-modal-scroll]',
        searchForm: 'form[action="/search"]',
        searchField: 'input[type="search"]',
        searchHistoryWrapper: '.initial__recent-searches',
        searchHistoryContainer: '[data-search-history-container]',
        searchHistoryClear: '[data-search-history-clear]',
        // Search Page
        searchSection: '[data-search]',
        noResultsCollection: '[data-no-results-collection]',
        noResultsCollectionLoadMore: '[data-no-results-collection-load-more]',
    };
    const classes = {
        searchModalShow: 'search-modal--show',
        searchHistoryContainerHidden: 'initial__recent-searches--hidden',
        searchHistoryItem: 'recent-searches__item',
        noResultsCollectionLimit: 'no-results-collection__items--4-items',
    };
    // Search Modal
    const searchModal = document.querySelector(selectors.searchModal);
    const searchModalToggles = document.querySelectorAll(selectors.searchModalToggle);
    const searchModalScrolls = document.querySelectorAll(selectors.searchModalScroll);
    const searchSection = document.querySelector(selectors.searchSection);
    if (searchModal && searchModalToggles) {
        searchModalToggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                document.body.classList.toggle(classes.searchModalShow);
                if (document.body.classList.contains(classes.searchModalShow)) {
                    const searchInput = searchModal.querySelector(selectors.searchField);
                    searchInput.focus();
                }
            });
        });
    }
    if (searchModalScrolls && searchSection) {
        searchModalScrolls.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const distance = searchSection.getBoundingClientRect().top;
                window.scroll({
                    top: distance,
                });
            });
        });
    }
    // Search History
    const searchForms = document.querySelectorAll(selectors.searchForm);
    let searchHistory = JSON.parse(sessionStorage.getItem('frank-green:search-history'));
    if (!searchHistory) {
        searchHistory = [];
    }
    searchForms.forEach((form) => {
        form.addEventListener('submit', () => {
            const searchField = form.querySelector(selectors.searchField);
            const searchTerm = searchField.value;
            searchHistory.push(searchTerm);
            // Unique Search Terms Only
            const uniqueSearches = searchHistory.filter((element, index) => {
                return searchHistory.indexOf(element) === index;
            });
            sessionStorage.setItem('frank-green:search-history', JSON.stringify(uniqueSearches));
        });
    });
    const searchHistoryWrapper = document.querySelector(selectors.searchHistoryWrapper);
    if (searchHistoryWrapper) {
        // Show Search History
        const searchHistoryContainer = searchHistoryWrapper.querySelector(selectors.searchHistoryContainer);
        if (searchHistoryContainer && searchHistory) {
            searchHistory.forEach((item) => {
                searchHistoryWrapper.classList.remove(classes.searchHistoryContainerHidden);
                const itemLink = document.createElement('a');
                const linkText = document.createTextNode(item);
                itemLink.classList.add(classes.searchHistoryItem);
                itemLink.appendChild(linkText);
                itemLink.href = '/search?q=' + item;
                searchHistoryContainer.append(itemLink);
            });
        }
        // Clear Search History
        const searchHistoryClear = document.querySelector(selectors.searchHistoryClear);
        if (searchHistoryClear) {
            searchHistoryClear.addEventListener('click', () => {
                searchHistory = [];
                sessionStorage.setItem('frank-green:search-history', JSON.stringify(searchHistory));
                searchHistoryWrapper.remove();
            });
        }
    }
    // Search Page
    if (searchSection) {
        // No Search Results
        const noResultsCollection = searchSection.querySelector(selectors.noResultsCollection);
        const noResultsCollectionLoadMore = searchSection.querySelector(selectors.noResultsCollectionLoadMore);
        if (noResultsCollection && noResultsCollectionLoadMore) {
            noResultsCollectionLoadMore.addEventListener('click', () => {
                noResultsCollection.classList.remove(classes.noResultsCollectionLimit);
            });
        }
    }
};
export { search };
